import {Inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of, of as observableOf} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';

import {Empresa, EmpresaService} from "../../../../../chacra-core";
import * as empresasActions from './empresas.actions';
import {ConfigService} from '../../../../../shared';
import {AUTH_ACCESS_TOKEN, AUTH_ROLE_ID} from '../../../../../core';
import {DOCUMENT} from '@angular/common';
import {LocalStorageService} from '../../../../../core/services';

@Injectable()
export class EmpresasEffects {
  EmpresasLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<empresasActions.EmpresasLoadRequestAction>(
      empresasActions.EmpresasActionTypes
        .EMPRESAS_LOAD_REQUEST
    ),
    switchMap((action) => {
      const rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
      let params: any = {rolId};
      return this.empresasCoreService.get(params).pipe(
        map(queryResults => {
          return new empresasActions.EmpresasLoadSuccessAction({
            items: queryResults.items
          });
        }),
        catchError(error =>
          observableOf(
            new empresasActions.EmpresasLoadFailureAction({error})
          )
        )
      );
    })
  ));

  // load
  EmpresasRegistrerRedirectEffect$: Observable<Action | Empresa> = createEffect(() => this.actions$.pipe(
    ofType<empresasActions.EmpresasRegistrerRedirectAction>(
      empresasActions.EmpresasActionTypes.EMPRESAS_REGISTRER_REDIRECT
    ),
    map(
      (action: empresasActions.EmpresasRegistrerRedirectAction) =>
        action.payload.item
    ),
    tap((item: Empresa) => {
      const reuneBaseUrl = ConfigService.getAppConfig().reuneBaseUrl;
      if (reuneBaseUrl !== '') {
        const accessToken = this.localStorageService.getItem(AUTH_ACCESS_TOKEN);
        const productiveEntityId = item !== undefined ? item.empresaId : 0;
        const callBackURL = this.document.defaultView.window.location.href;
        const url = `${reuneBaseUrl}registrodeentidadproductiva.aspx?1,${productiveEntityId},${callBackURL}`;
        this.document.defaultView.window.open(url, '_self');
      } else {
        console.error('Debe configurar el valor de reuneBaseUrl en su config.json');
        of(
          new empresasActions.EmpresasRegistrerFailureAction({
            error: 'Ha ocurrido un error en el registro de empresa en el REUNE.'
          })
        );
      }
    })
  ), {dispatch: false});

  // registre

  constructor(
    private empresasCoreService: EmpresaService,
    private actions$: Actions,
    @Inject(DOCUMENT) readonly document: Document,
    private localStorageService: LocalStorageService
  ) {
  }
}
